// GENERIERT von scripts/generate_rbac.py aus docs/rbac/permissions.json — nicht bearbeiten.
// Quelle-SHA256: 3efa456014d6aae2022220f368602f9b91f2c7e92c3905700de01184acacb392
//
// Permission-Keys für UI-Checks (usePermission / <Can>). Welche Keys ein Benutzer
// besitzt, liefert ausschließlich der Server — hier gibt es bewusst keine
// Rollenmatrix.

export const P = {
  dashboard: {
    "dashboard_ansehen": "dashboard.dashboard_ansehen",
    "eigene_kennzahlen_ansehen": "dashboard.eigene_kennzahlen_ansehen",
    "teamkennzahlen": "dashboard.teamkennzahlen",
    "standortkennzahlen": "dashboard.standortkennzahlen",
    "unternehmenskennzahlen": "dashboard.unternehmenskennzahlen",
    "dashboard_konfigurieren": "dashboard.dashboard_konfigurieren",
    "eigene_widgets_hinzufuegen_entfernen": "dashboard.eigene_widgets_hinzufuegen_entfernen",
    "individuelle_dashboards_erstellen": "dashboard.individuelle_dashboards_erstellen",
    "globale_dashboard_widgets_konfigurieren": "dashboard.globale_dashboard_widgets_konfigurieren",
    "globale_dashboards_verwalten": "dashboard.globale_dashboards_verwalten",
  },
  arbeit: {
    aufgaben: {
      "aufgaben_ansehen": "arbeit.aufgaben.aufgaben_ansehen",
      "aufgaben_erstellen": "arbeit.aufgaben.aufgaben_erstellen",
      "aufgabe_bearbeiten": "arbeit.aufgaben.aufgabe_bearbeiten",
      "aufgabe_erledigen": "arbeit.aufgaben.aufgabe_erledigen",
      "faelligkeit_aendern": "arbeit.aufgaben.faelligkeit_aendern",
      "aufgabe_zuweisen": "arbeit.aufgaben.aufgabe_zuweisen",
      "aufgabe_delegieren": "arbeit.aufgaben.aufgabe_delegieren",
      "prioritaet_aendern": "arbeit.aufgaben.prioritaet_aendern",
      "aufgabe_kommentieren": "arbeit.aufgaben.aufgabe_kommentieren",
      "anhaenge_verwalten": "arbeit.aufgaben.anhaenge_verwalten",
      "datensaetze_verknuepfen": "arbeit.aufgaben.datensaetze_verknuepfen",
      "aufgabe_archivieren_ausblenden": "arbeit.aufgaben.aufgabe_archivieren_ausblenden",
      "aufgabe_loeschen": "arbeit.aufgaben.aufgabe_loeschen",
      "aenderungshistorie_ansehen": "arbeit.aufgaben.aenderungshistorie_ansehen",
    },
    kalendereintraege: {
      "eigene_eintraege_ansehen": "arbeit.kalendereintraege.eigene_eintraege_ansehen",
      "eintraege_erstellen": "arbeit.kalendereintraege.eintraege_erstellen",
      "eigene_eintraege_bearbeiten": "arbeit.kalendereintraege.eigene_eintraege_bearbeiten",
      "eigene_eintraege_loeschen": "arbeit.kalendereintraege.eigene_eintraege_loeschen",
      "andere_teilnehmer_einladen": "arbeit.kalendereintraege.andere_teilnehmer_einladen",
      "team_eintraege_ansehen": "arbeit.kalendereintraege.team_eintraege_ansehen",
      "team_eintraege_verwalten": "arbeit.kalendereintraege.team_eintraege_verwalten",
    },
  },
  personen: {
    personen: {
      "person_ansehen": "personen.personen.person_ansehen",
      "person_erstellen": "personen.personen.person_erstellen",
      "person_bearbeiten": "personen.personen.person_bearbeiten",
      "person_archivieren": "personen.personen.person_archivieren",
      "person_loeschen": "personen.personen.person_loeschen",
      "person_zusammenfuehren": "personen.personen.person_zusammenfuehren",
      "personenhistorie_ansehen": "personen.personen.personenhistorie_ansehen",
      "personenhistorie_bearbeiten": "personen.personen.personenhistorie_bearbeiten",
      "personenhistorie_loeschen": "personen.personen.personenhistorie_loeschen",
      "personendokumente_ansehen": "personen.personen.personendokumente_ansehen",
      "personendokumente_verwalten": "personen.personen.personendokumente_verwalten",
    },
    accounts: {
      "account_ansehen": "personen.accounts.account_ansehen",
      "account_erstellen": "personen.accounts.account_erstellen",
      "account_bearbeiten": "personen.accounts.account_bearbeiten",
      "account_archivieren": "personen.accounts.account_archivieren",
      "account_loeschen": "personen.accounts.account_loeschen",
      "account_zugriff_verwalten": "personen.accounts.account_zugriff_verwalten",
      "profile_eines_accounts_ansehen": "personen.accounts.profile_eines_accounts_ansehen",
      "account_historie_ansehen": "personen.accounts.account_historie_ansehen",
    },
    profile: {
      "profile_ansehen": "personen.profile.profile_ansehen",
      "profil_erstellen": "personen.profile.profil_erstellen",
      "profil_bearbeiten": "personen.profile.profil_bearbeiten",
      "profil_archivieren": "personen.profile.profil_archivieren",
      "profil_loeschen": "personen.profile.profil_loeschen",
      "profil_einem_account_zuordnen": "personen.profile.profil_einem_account_zuordnen",
      "profil_aus_account_entfernen": "personen.profile.profil_aus_account_entfernen",
      "profilrolle_hinzufuegen": "personen.profile.profilrolle_hinzufuegen",
      "profilhistorie_ansehen": "personen.profile.profilhistorie_ansehen",
      "profil_dokumente_ansehen": "personen.profile.profil_dokumente_ansehen",
      "profil_dokumente_verwalten": "personen.profile.profil_dokumente_verwalten",
    },
  },
  anfragen: {
    "anfragen_ansehen": "anfragen.anfragen_ansehen",
    "anfragen_in_probestunde_umwandeln": "anfragen.anfragen_in_probestunde_umwandeln",
    "anfrage_als_favoriten_hinzufuegen": "anfragen.anfrage_als_favoriten_hinzufuegen",
    "anfrage_archivieren": "anfragen.anfrage_archivieren",
    "anfrage_bearbeiten": "anfragen.anfrage_bearbeiten",
    "anfrage_loeschen": "anfragen.anfrage_loeschen",
    "anfragenhistorie_ansehen": "anfragen.anfragenhistorie_ansehen",
    "anfragenhistorie_loeschen": "anfragen.anfragenhistorie_loeschen",
    "anfrage_mit_person_verknuepfen": "anfragen.anfrage_mit_person_verknuepfen",
    "anruf_aus_anfrage_starten": "anfragen.anruf_aus_anfrage_starten",
    "sms_aus_anfrage_versenden": "anfragen.sms_aus_anfrage_versenden",
    "e_mail_aus_anfrage_versenden": "anfragen.e_mail_aus_anfrage_versenden",
    "kommentar_hinzufuegen": "anfragen.kommentar_hinzufuegen",
  },
  anmeldung: {
    "eintrag_ansehen": "anmeldung.eintrag_ansehen",
    "kuendigungen_ansehen": "anmeldung.kuendigungen_ansehen",
    "eintrag_bearbeiten": "anmeldung.eintrag_bearbeiten",
    "eintrag_archivieren": "anmeldung.eintrag_archivieren",
    "eintrag_loeschen": "anmeldung.eintrag_loeschen",
    "als_favorit_hinzufuegen": "anmeldung.als_favorit_hinzufuegen",
    "einmalcode_ausstellen": "anmeldung.einmalcode_ausstellen",
    "historie_einsehen": "anmeldung.historie_einsehen",
    "historie_loeschen": "anmeldung.historie_loeschen",
    "anruf_aus_eintrag_starten": "anmeldung.anruf_aus_eintrag_starten",
    "sms_aus_eintrag_versenden": "anmeldung.sms_aus_eintrag_versenden",
    "e_mail_aus_eintrag_versenden": "anmeldung.e_mail_aus_eintrag_versenden",
    "kommentar_hinzufuegen": "anmeldung.kommentar_hinzufuegen",
  },
  termine: {
    "eintraege_ansehen": "termine.eintraege_ansehen",
    "eintraege_bearbeiten": "termine.eintraege_bearbeiten",
    "eintraege_loeschen": "termine.eintraege_loeschen",
    "kommentare_hinzufuegen": "termine.kommentare_hinzufuegen",
  },
  raumplan: {
    "raeume_ansehen": "raumplan.raeume_ansehen",
    "raeume_bearbeiten": "raumplan.raeume_bearbeiten",
    "raeume_anlegen": "raumplan.raeume_anlegen",
    "raeume_de_aktivieren": "raumplan.raeume_de_aktivieren",
    "raeume_loeschen": "raumplan.raeume_loeschen",
    "belegungsplan_bearbeiten": "raumplan.belegungsplan_bearbeiten",
    "auslastung_ansehen": "raumplan.auslastung_ansehen",
    "wirtschaftliche_kennzahlen_ansehen": "raumplan.wirtschaftliche_kennzahlen_ansehen",
    "raumhistorie_ansehen": "raumplan.raumhistorie_ansehen",
    "kommentare_hinzufuegen": "raumplan.kommentare_hinzufuegen",
  },
  personenlisten: {
    "personenlisten_ansehen": "personenlisten.personenlisten_ansehen",
    "personenlisten_erstellen": "personenlisten.personenlisten_erstellen",
    "personenliste_bearbeiten": "personenlisten.personenliste_bearbeiten",
    "personenliste_teilen": "personenlisten.personenliste_teilen",
    "personenliste_archivieren": "personenlisten.personenliste_archivieren",
    "personenliste_loeschen": "personenlisten.personenliste_loeschen",
    "personen_einer_liste_ansehen": "personenlisten.personen_einer_liste_ansehen",
    "personenliste_exportieren": "personenlisten.personenliste_exportieren",
    "fuer_e_mail_verteiler_verwenden": "personenlisten.fuer_e_mail_verteiler_verwenden",
    "fuer_sms_verteiler_verwenden": "personenlisten.fuer_sms_verteiler_verwenden",
    "fuer_newsletter_verwenden": "personenlisten.fuer_newsletter_verwenden",
    "fuer_kundenbereich_anzeige_verwenden": "personenlisten.fuer_kundenbereich_anzeige_verwenden",
    "personenliste_kommentieren": "personenlisten.personenliste_kommentieren",
  },
  buchhaltung: {
    finanzdaten_und_zahlungen: {
      "finanzdaten_ansehen": "buchhaltung.finanzdaten_und_zahlungen.finanzdaten_ansehen",
      "finanzdaten_bearbeiten": "buchhaltung.finanzdaten_und_zahlungen.finanzdaten_bearbeiten",
      "zahlungen_ansehen": "buchhaltung.finanzdaten_und_zahlungen.zahlungen_ansehen",
      "zahlungen_bearbeiten": "buchhaltung.finanzdaten_und_zahlungen.zahlungen_bearbeiten",
      "zahlung_erfassen": "buchhaltung.finanzdaten_und_zahlungen.zahlung_erfassen",
      "zahlung_zurueckerstatten": "buchhaltung.finanzdaten_und_zahlungen.zahlung_zurueckerstatten",
      "offene_posten_ansehen": "buchhaltung.finanzdaten_und_zahlungen.offene_posten_ansehen",
      "offene_posten_bearbeiten": "buchhaltung.finanzdaten_und_zahlungen.offene_posten_bearbeiten",
      "liquiditaetsprognose_ansehen": "buchhaltung.finanzdaten_und_zahlungen.liquiditaetsprognose_ansehen",
    },
    ruecklastschriften_und_mahnwesen: {
      "ruecklastschriften_ansehen": "buchhaltung.ruecklastschriften_und_mahnwesen.ruecklastschriften_ansehen",
      "ruecklastschriften_bearbeiten": "buchhaltung.ruecklastschriften_und_mahnwesen.ruecklastschriften_bearbeiten",
      "mahnwesen_ansehen": "buchhaltung.ruecklastschriften_und_mahnwesen.mahnwesen_ansehen",
      "mahnwesen_bearbeiten": "buchhaltung.ruecklastschriften_und_mahnwesen.mahnwesen_bearbeiten",
      "mahnungen_erstellen_versenden": "buchhaltung.ruecklastschriften_und_mahnwesen.mahnungen_erstellen_versenden",
    },
    buchhaltungsbelege_und_dokumente: {
      "finanzdokumente_ansehen": "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_ansehen",
      "finanzdokumente_erstellen": "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_erstellen",
      "finanzdokumente_bearbeiten": "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_bearbeiten",
      "finanzdokumente_archivieren": "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_archivieren",
      "finanzdokumente_loeschen": "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_loeschen",
    },
  },
  standort: {
    standort_stammdaten: {
      "standortdaten_ansehen": "standort.standort_stammdaten.standortdaten_ansehen",
      "standortdaten_bearbeiten": "standort.standort_stammdaten.standortdaten_bearbeiten",
      "standort_archivieren": "standort.standort_stammdaten.standort_archivieren",
      "standort_loeschen": "standort.standort_stammdaten.standort_loeschen",
      "standorthistorie_ansehen": "standort.standort_stammdaten.standorthistorie_ansehen",
      "kommentare_hinzufuegen": "standort.standort_stammdaten.kommentare_hinzufuegen",
    },
    raeume_und_ausstattung: {
      "raumkonfiguration_ansehen": "standort.raeume_und_ausstattung.raumkonfiguration_ansehen",
      "raumkonfiguration_bearbeiten": "standort.raeume_und_ausstattung.raumkonfiguration_bearbeiten",
      "ausstattung_verwalten": "standort.raeume_und_ausstattung.ausstattung_verwalten",
      "kommentare_hinzufuegen": "standort.raeume_und_ausstattung.kommentare_hinzufuegen",
    },
    unterrichtsangebot: {
      "unterrichtsangebot_ansehen": "standort.unterrichtsangebot.unterrichtsangebot_ansehen",
      "unterrichtsangebot_bearbeiten": "standort.unterrichtsangebot.unterrichtsangebot_bearbeiten",
      "unterrichtsangebot_de_aktivieren": "standort.unterrichtsangebot.unterrichtsangebot_de_aktivieren",
      "kommentare_hinzufuegen": "standort.unterrichtsangebot.kommentare_hinzufuegen",
    },
    unterrichtsformen_und_pakete: {
      "unterrichtsformen_ansehen": "standort.unterrichtsformen_und_pakete.unterrichtsformen_ansehen",
      "unterrichtsformen_bearbeiten": "standort.unterrichtsformen_und_pakete.unterrichtsformen_bearbeiten",
      "unterrichtsformen_de_aktivieren": "standort.unterrichtsformen_und_pakete.unterrichtsformen_de_aktivieren",
      "pakete_ansehen": "standort.unterrichtsformen_und_pakete.pakete_ansehen",
      "pakete_bearbeiten": "standort.unterrichtsformen_und_pakete.pakete_bearbeiten",
      "pakete_de_aktivieren": "standort.unterrichtsformen_und_pakete.pakete_de_aktivieren",
      "kommentare_hinzufuegen": "standort.unterrichtsformen_und_pakete.kommentare_hinzufuegen",
    },
    vertragsregularien: {
      "vertragsregularien_ansehen": "standort.vertragsregularien.vertragsregularien_ansehen",
      "vertragsregularien_bearbeiten": "standort.vertragsregularien.vertragsregularien_bearbeiten",
      "vertragsregularien_de_aktivieren": "standort.vertragsregularien.vertragsregularien_de_aktivieren",
      "kommentare_hinzufuegen": "standort.vertragsregularien.kommentare_hinzufuegen",
      "historie_ansehen": "standort.vertragsregularien.historie_ansehen",
    },
    benutzer_und_zugriffsrechte: {
      "standortbenutzer_ansehen": "standort.benutzer_und_zugriffsrechte.standortbenutzer_ansehen",
      "standortbenutzer_hinzufuegen": "standort.benutzer_und_zugriffsrechte.standortbenutzer_hinzufuegen",
      "standortbenutzer_entfernen": "standort.benutzer_und_zugriffsrechte.standortbenutzer_entfernen",
      "standortbezogene_rolle_vergeben": "standort.benutzer_und_zugriffsrechte.standortbezogene_rolle_vergeben",
      "standortbezogene_berechtigungen_bearbeiten": "standort.benutzer_und_zugriffsrechte.standortbezogene_berechtigungen_bearbeiten",
      "standortbenutzer_deaktivieren": "standort.benutzer_und_zugriffsrechte.standortbenutzer_deaktivieren",
      "benutzerhistorie_ansehen": "standort.benutzer_und_zugriffsrechte.benutzerhistorie_ansehen",
    },
  },
  recruiting: {
    jobangebote: {
      "jobangebote_ansehen": "recruiting.jobangebote.jobangebote_ansehen",
      "jobangebote_erstellen": "recruiting.jobangebote.jobangebote_erstellen",
      "jobangebote_bearbeiten": "recruiting.jobangebote.jobangebote_bearbeiten",
      "jobangebote_veroeffentlichen": "recruiting.jobangebote.jobangebote_veroeffentlichen",
      "jobangebote_deaktivieren": "recruiting.jobangebote.jobangebote_deaktivieren",
      "jobangebote_archivieren": "recruiting.jobangebote.jobangebote_archivieren",
      "jobangebote_loeschen": "recruiting.jobangebote.jobangebote_loeschen",
      "jobangebots_historie_ansehen": "recruiting.jobangebote.jobangebots_historie_ansehen",
      "kommentar_hinzufuegen": "recruiting.jobangebote.kommentar_hinzufuegen",
    },
    bewerbungen: {
      "bewerbungen_ansehen": "recruiting.bewerbungen.bewerbungen_ansehen",
      "bewerbungen_bearbeiten": "recruiting.bewerbungen.bewerbungen_bearbeiten",
      "bewerbungen_archivieren": "recruiting.bewerbungen.bewerbungen_archivieren",
      "bewerbung_loeschen": "recruiting.bewerbungen.bewerbung_loeschen",
      "bewerbung_einem_jobangebot_zuordnen": "recruiting.bewerbungen.bewerbung_einem_jobangebot_zuordnen",
      "bewerbungsstatus_aendern": "recruiting.bewerbungen.bewerbungsstatus_aendern",
      "bewerbung_kommentieren": "recruiting.bewerbungen.bewerbung_kommentieren",
      "bewerbungshistorie_ansehen": "recruiting.bewerbungen.bewerbungshistorie_ansehen",
      "bewerbungsdokumente_ansehen": "recruiting.bewerbungen.bewerbungsdokumente_ansehen",
      "bewerbungsdokumente_verwalten": "recruiting.bewerbungen.bewerbungsdokumente_verwalten",
      "bewerber_kontaktieren": "recruiting.bewerbungen.bewerber_kontaktieren",
    },
  },
  cms: {
    inhalte: {
      "inhalte_ansehen": "cms.inhalte.inhalte_ansehen",
      "inhalte_erstellen": "cms.inhalte.inhalte_erstellen",
      "inhalte_bearbeiten": "cms.inhalte.inhalte_bearbeiten",
      "inhalte_veroeffentlichen": "cms.inhalte.inhalte_veroeffentlichen",
      "inhalte_deaktivieren": "cms.inhalte.inhalte_deaktivieren",
      "inhalte_archivieren": "cms.inhalte.inhalte_archivieren",
      "inhalte_loeschen": "cms.inhalte.inhalte_loeschen",
      "medien_verwalten": "cms.inhalte.medien_verwalten",
      "kommentare_hinzufuegen": "cms.inhalte.kommentare_hinzufuegen",
      "inhalte_historie_ansehen": "cms.inhalte.inhalte_historie_ansehen",
    },
    website_struktur: {
      "website_struktur_ansehen": "cms.website_struktur.website_struktur_ansehen",
      "website_struktur_bearbeiten": "cms.website_struktur.website_struktur_bearbeiten",
      "seiten_erstellen": "cms.website_struktur.seiten_erstellen",
      "seiten_loeschen": "cms.website_struktur.seiten_loeschen",
      "seiten_verschieben": "cms.website_struktur.seiten_verschieben",
      "navigation_bearbeiten": "cms.website_struktur.navigation_bearbeiten",
      "website_hierarchie_bearbeiten": "cms.website_struktur.website_hierarchie_bearbeiten",
    },
  },
  auswertungen: {
    standard_und_individuelle_auswertungen: {
      "auswertungen_ansehen": "auswertungen.standard_und_individuelle_auswertungen.auswertungen_ansehen",
      "individuelle_auswertungen_erstellen": "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_erstellen",
      "individuelle_auswertungen_speichern": "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_speichern",
      "individuelle_auswertungen_bearbeiten": "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_bearbeiten",
      "individuelle_auswertungen_archivieren": "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_archivieren",
      "individuelle_auswertungen_loeschen": "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_loeschen",
      "auswertungen_exportieren": "auswertungen.standard_und_individuelle_auswertungen.auswertungen_exportieren",
      "auswertungen_kommentieren": "auswertungen.standard_und_individuelle_auswertungen.auswertungen_kommentieren",
      "auswertungen_teilen": "auswertungen.standard_und_individuelle_auswertungen.auswertungen_teilen",
    },
    ki_gestuetzte_auswertungen: {
      "ki_auswertungen_verwenden": "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_verwenden",
      "ki_auswertungen_speichern": "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_speichern",
      "ki_auswertungen_teilen": "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_teilen",
      "ki_auswertungen_exportieren": "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_exportieren",
      "ki_auswertungen_loeschen": "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_loeschen",
      "ki_datenzugriff_konfigurieren": "auswertungen.ki_gestuetzte_auswertungen.ki_datenzugriff_konfigurieren",
    },
  },
  admin: {
    globale_angebote: {
      "globale_angebote_ansehen": "admin.globale_angebote.globale_angebote_ansehen",
      "globale_angebote_erstellen": "admin.globale_angebote.globale_angebote_erstellen",
      "globales_angebot_bearbeiten": "admin.globale_angebote.globales_angebot_bearbeiten",
      "globales_angebot_de_aktivieren": "admin.globale_angebote.globales_angebot_de_aktivieren",
      "globales_angebot_archivieren": "admin.globale_angebote.globales_angebot_archivieren",
      "globales_angebot_loeschen": "admin.globale_angebote.globales_angebot_loeschen",
      "historie_ansehen": "admin.globale_angebote.historie_ansehen",
      "kommentare_hinzufuegen": "admin.globale_angebote.kommentare_hinzufuegen",
    },
    standorte: {
      "standorte_ansehen": "admin.standorte.standorte_ansehen",
      "standort_anlegen": "admin.standorte.standort_anlegen",
      "standort_bearbeiten": "admin.standorte.standort_bearbeiten",
      "standort_archivieren": "admin.standorte.standort_archivieren",
      "standort_loeschen": "admin.standorte.standort_loeschen",
      "standorthistorie_ansehen": "admin.standorte.standorthistorie_ansehen",
    },
    benutzer_und_rollen: {
      "benutzer_ansehen": "admin.benutzer_und_rollen.benutzer_ansehen",
      "benutzer_anlegen": "admin.benutzer_und_rollen.benutzer_anlegen",
      "benutzer_bearbeiten": "admin.benutzer_und_rollen.benutzer_bearbeiten",
      "benutzer_de_aktivieren": "admin.benutzer_und_rollen.benutzer_de_aktivieren",
      "benutzer_loeschen": "admin.benutzer_und_rollen.benutzer_loeschen",
      "rollen_vergeben": "admin.benutzer_und_rollen.rollen_vergeben",
      "berechtigungen_bearbeiten": "admin.benutzer_und_rollen.berechtigungen_bearbeiten",
      "standortzuordnung_verwalten": "admin.benutzer_und_rollen.standortzuordnung_verwalten",
      "benutzerhistorie_ansehen": "admin.benutzer_und_rollen.benutzerhistorie_ansehen",
    },
    sicherheit: {
      "sicherheitseinstellungen_ansehen": "admin.sicherheit.sicherheitseinstellungen_ansehen",
      "sicherheitseinstellungen_bearbeiten": "admin.sicherheit.sicherheitseinstellungen_bearbeiten",
      "2fa_richtlinien_verwalten": "admin.sicherheit.2fa_richtlinien_verwalten",
      "passwortrichtlinien_verwalten": "admin.sicherheit.passwortrichtlinien_verwalten",
      "anmelderichtlinien_verwalten": "admin.sicherheit.anmelderichtlinien_verwalten",
      "sitzungsrichtlinien_verwalten": "admin.sicherheit.sitzungsrichtlinien_verwalten",
      "sicherheitsprotokolle_ansehen": "admin.sicherheit.sicherheitsprotokolle_ansehen",
      "benutzersitzungen_verwalten": "admin.sicherheit.benutzersitzungen_verwalten",
      "sicherheitsereignisse_verwalten": "admin.sicherheit.sicherheitsereignisse_verwalten",
    },
    migration_und_daten: {
      "migrationskonfiguration_ansehen": "admin.migration_und_daten.migrationskonfiguration_ansehen",
      "migrationskonfiguration_bearbeiten": "admin.migration_und_daten.migrationskonfiguration_bearbeiten",
      "datenimport_durchfuehren": "admin.migration_und_daten.datenimport_durchfuehren",
      "datenexport_durchfuehren": "admin.migration_und_daten.datenexport_durchfuehren",
      "migration_starten": "admin.migration_und_daten.migration_starten",
      "migration_abbrechen": "admin.migration_und_daten.migration_abbrechen",
      "migration_archivieren": "admin.migration_und_daten.migration_archivieren",
      "migration_loeschen": "admin.migration_und_daten.migration_loeschen",
      "migrationshistorie_ansehen": "admin.migration_und_daten.migrationshistorie_ansehen",
      "import_exportprotokolle_ansehen": "admin.migration_und_daten.import_exportprotokolle_ansehen",
    },
    zahlungswesen_und_integrationen: {
      "zahlungsintegration_ansehen": "admin.zahlungswesen_und_integrationen.zahlungsintegration_ansehen",
      "zahlungsintegration_konfigurieren": "admin.zahlungswesen_und_integrationen.zahlungsintegration_konfigurieren",
      "zahlungsintegration_de_aktivieren": "admin.zahlungswesen_und_integrationen.zahlungsintegration_de_aktivieren",
      "zahlungsarten_konfigurieren": "admin.zahlungswesen_und_integrationen.zahlungsarten_konfigurieren",
      "zahlungsparameter_konfigurieren": "admin.zahlungswesen_und_integrationen.zahlungsparameter_konfigurieren",
      "zahlungsintegration_testen": "admin.zahlungswesen_und_integrationen.zahlungsintegration_testen",
      "zahlungsintegration_loeschen": "admin.zahlungswesen_und_integrationen.zahlungsintegration_loeschen",
      "zahlungsintegrations_historie_ansehen": "admin.zahlungswesen_und_integrationen.zahlungsintegrations_historie_ansehen",
    },
    vorlagen: {
      "vorlagen_ansehen": "admin.vorlagen.vorlagen_ansehen",
      "vorlagen_verwenden": "admin.vorlagen.vorlagen_verwenden",
      "vorlagen_erstellen": "admin.vorlagen.vorlagen_erstellen",
      "vorlagen_bearbeiten": "admin.vorlagen.vorlagen_bearbeiten",
      "vorlagen_de_aktivieren": "admin.vorlagen.vorlagen_de_aktivieren",
      "vorlagen_archivieren": "admin.vorlagen.vorlagen_archivieren",
      "vorlagen_loeschen": "admin.vorlagen.vorlagen_loeschen",
      "vorlagenhistorie_ansehen": "admin.vorlagen.vorlagenhistorie_ansehen",
      "kommentare_hinzufuegen": "admin.vorlagen.kommentare_hinzufuegen",
    },
    oeffentliche_bereiche: {
      "oeffentliche_bereiche_ansehen": "admin.oeffentliche_bereiche.oeffentliche_bereiche_ansehen",
      "oeffentliche_bereiche_bearbeiten": "admin.oeffentliche_bereiche.oeffentliche_bereiche_bearbeiten",
      "kunden_login_konfigurieren": "admin.oeffentliche_bereiche.kunden_login_konfigurieren",
      "oeffentliche_formulare_konfigurieren": "admin.oeffentliche_bereiche.oeffentliche_formulare_konfigurieren",
      "oeffentliche_funktionen_de_aktivieren": "admin.oeffentliche_bereiche.oeffentliche_funktionen_de_aktivieren",
      "oeffentliche_konfiguration_archivieren": "admin.oeffentliche_bereiche.oeffentliche_konfiguration_archivieren",
      "oeffentliche_konfiguration_loeschen": "admin.oeffentliche_bereiche.oeffentliche_konfiguration_loeschen",
      "historie_ansehen": "admin.oeffentliche_bereiche.historie_ansehen",
    },
    system_und_schnittstellen: {
      "systemeinstellungen_ansehen": "admin.system_und_schnittstellen.systemeinstellungen_ansehen",
      "systemeinstellungen_bearbeiten": "admin.system_und_schnittstellen.systemeinstellungen_bearbeiten",
      "api_schnittstellen_ansehen": "admin.system_und_schnittstellen.api_schnittstellen_ansehen",
      "api_schnittstellen_konfigurieren": "admin.system_und_schnittstellen.api_schnittstellen_konfigurieren",
      "api_schnittstellen_de_aktivieren": "admin.system_und_schnittstellen.api_schnittstellen_de_aktivieren",
      "api_schnittstellen_testen": "admin.system_und_schnittstellen.api_schnittstellen_testen",
      "api_schnittstellen_loeschen": "admin.system_und_schnittstellen.api_schnittstellen_loeschen",
      "wartungsmodus_verwalten": "admin.system_und_schnittstellen.wartungsmodus_verwalten",
      "zeitzonen_verwalten": "admin.system_und_schnittstellen.zeitzonen_verwalten",
      "terminintervalle_verwalten": "admin.system_und_schnittstellen.terminintervalle_verwalten",
      "termin_ranges_verwalten": "admin.system_und_schnittstellen.termin_ranges_verwalten",
      "systemhistorie_ansehen": "admin.system_und_schnittstellen.systemhistorie_ansehen",
    },
    storage_und_dateien: {
      "storage_ansehen": "admin.storage_und_dateien.storage_ansehen",
      "storage_konfigurieren": "admin.storage_und_dateien.storage_konfigurieren",
      "speicherbereiche_verwalten": "admin.storage_und_dateien.speicherbereiche_verwalten",
      "speicherlimits_konfigurieren": "admin.storage_und_dateien.speicherlimits_konfigurieren",
      "dateien_verwalten": "admin.storage_und_dateien.dateien_verwalten",
      "dateien_loeschen": "admin.storage_und_dateien.dateien_loeschen",
      "storage_historie_ansehen": "admin.storage_und_dateien.storage_historie_ansehen",
    },
    datenschutz: {
      "datenschutzeinstellungen_ansehen": "admin.datenschutz.datenschutzeinstellungen_ansehen",
      "datenschutzeinstellungen_bearbeiten": "admin.datenschutz.datenschutzeinstellungen_bearbeiten",
      "dsgvo_anfragen_ansehen": "admin.datenschutz.dsgvo_anfragen_ansehen",
      "dsgvo_anfragen_bearbeiten": "admin.datenschutz.dsgvo_anfragen_bearbeiten",
      "datenexport_fuer_betroffene_person_durchfuehren": "admin.datenschutz.datenexport_fuer_betroffene_person_durchfuehren",
      "loeschanfrage_bearbeiten": "admin.datenschutz.loeschanfrage_bearbeiten",
      "datensaetze_anonymisieren": "admin.datenschutz.datensaetze_anonymisieren",
      "aufbewahrungsregeln_verwalten": "admin.datenschutz.aufbewahrungsregeln_verwalten",
      "datenschutzprotokoll_ansehen": "admin.datenschutz.datenschutzprotokoll_ansehen",
      "datenschutz_historie_ansehen": "admin.datenschutz.datenschutz_historie_ansehen",
    },
    protokollierung_und_logs: {
      "logs_ansehen": "admin.protokollierung_und_logs.logs_ansehen",
      "audit_logs_ansehen": "admin.protokollierung_und_logs.audit_logs_ansehen",
      "sicherheitslogs_ansehen": "admin.protokollierung_und_logs.sicherheitslogs_ansehen",
      "integrationslogs_ansehen": "admin.protokollierung_und_logs.integrationslogs_ansehen",
      "migrationslogs_ansehen": "admin.protokollierung_und_logs.migrationslogs_ansehen",
      "logs_exportieren": "admin.protokollierung_und_logs.logs_exportieren",
      "logs_loeschen": "admin.protokollierung_und_logs.logs_loeschen",
    },
    ki: {
      "ki_konfiguration_ansehen": "admin.ki.ki_konfiguration_ansehen",
      "ki_konfiguration_bearbeiten": "admin.ki.ki_konfiguration_bearbeiten",
      "ki_assistenten_verwalten": "admin.ki.ki_assistenten_verwalten",
      "ki_assistenten_de_aktivieren": "admin.ki.ki_assistenten_de_aktivieren",
      "ki_datenzugriffe_verwalten": "admin.ki.ki_datenzugriffe_verwalten",
      "ki_modelle_anbieter_verwalten": "admin.ki.ki_modelle_anbieter_verwalten",
      "ki_konfigurationshistorie_ansehen": "admin.ki.ki_konfigurationshistorie_ansehen",
    },
    automatisierung: {
      "automatisierung_ansehen": "admin.automatisierung.automatisierung_ansehen",
      "automatisierung_erstellen": "admin.automatisierung.automatisierung_erstellen",
      "automatisierung_bearbeiten": "admin.automatisierung.automatisierung_bearbeiten",
      "automatisierung_de_aktivieren": "admin.automatisierung.automatisierung_de_aktivieren",
      "automatisierung_archivieren": "admin.automatisierung.automatisierung_archivieren",
      "automatisierung_loeschen": "admin.automatisierung.automatisierung_loeschen",
      "automatisierungshistorie_ansehen": "admin.automatisierung.automatisierungshistorie_ansehen",
    },
    unternehmen_und_erscheinungsbild: {
      "unternehmensdaten_ansehen": "admin.unternehmen_und_erscheinungsbild.unternehmensdaten_ansehen",
      "unternehmensdaten_bearbeiten": "admin.unternehmen_und_erscheinungsbild.unternehmensdaten_bearbeiten",
      "erscheinungsbild_ansehen": "admin.unternehmen_und_erscheinungsbild.erscheinungsbild_ansehen",
      "erscheinungsbild_bearbeiten": "admin.unternehmen_und_erscheinungsbild.erscheinungsbild_bearbeiten",
      "unternehmenskonfiguration_archivieren": "admin.unternehmen_und_erscheinungsbild.unternehmenskonfiguration_archivieren",
      "unternehmenshistorie_ansehen": "admin.unternehmen_und_erscheinungsbild.unternehmenshistorie_ansehen",
      "kommentare_hinzufuegen": "admin.unternehmen_und_erscheinungsbild.kommentare_hinzufuegen",
    },
    verkaufsaktionen: {
      "gutscheine_und_rabattcodes_ansehen": "admin.verkaufsaktionen.gutscheine_und_rabattcodes_ansehen",
      "gutscheine_und_rabattcodes_erstellen": "admin.verkaufsaktionen.gutscheine_und_rabattcodes_erstellen",
      "gutscheine_und_rabattcodes_bearbeiten": "admin.verkaufsaktionen.gutscheine_und_rabattcodes_bearbeiten",
      "gutscheine_und_rabattcodes_de_aktivieren": "admin.verkaufsaktionen.gutscheine_und_rabattcodes_de_aktivieren",
      "gutscheine_und_rabattcodes_archivieren": "admin.verkaufsaktionen.gutscheine_und_rabattcodes_archivieren",
      "gutscheine_und_rabattcodes_loeschen": "admin.verkaufsaktionen.gutscheine_und_rabattcodes_loeschen",
      "affiliate_codes_ansehen": "admin.verkaufsaktionen.affiliate_codes_ansehen",
      "affiliate_codes_bearbeiten": "admin.verkaufsaktionen.affiliate_codes_bearbeiten",
      "affiliate_codes_de_aktivieren": "admin.verkaufsaktionen.affiliate_codes_de_aktivieren",
      "affiliate_codes_archivieren": "admin.verkaufsaktionen.affiliate_codes_archivieren",
      "affiliate_codes_loeschen": "admin.verkaufsaktionen.affiliate_codes_loeschen",
      "nutzung_ansehen": "admin.verkaufsaktionen.nutzung_ansehen",
      "historie_ansehen": "admin.verkaufsaktionen.historie_ansehen",
    },
  },
  marketing: {
    kampagnen: {
      "kampagnen_ansehen": "marketing.kampagnen.kampagnen_ansehen",
      "kampagnen_erstellen": "marketing.kampagnen.kampagnen_erstellen",
      "kampagnen_bearbeiten": "marketing.kampagnen.kampagnen_bearbeiten",
      "kampagnen_de_aktivieren": "marketing.kampagnen.kampagnen_de_aktivieren",
      "kampagnen_archivieren": "marketing.kampagnen.kampagnen_archivieren",
      "kampagnen_loeschen": "marketing.kampagnen.kampagnen_loeschen",
      "kampagnenhistorie_ansehen": "marketing.kampagnen.kampagnenhistorie_ansehen",
      "kommentare_hinzufuegen": "marketing.kampagnen.kommentare_hinzufuegen",
    },
    marketing_auswertungen: {
      "marketing_auswertungen_ansehen": "marketing.marketing_auswertungen.marketing_auswertungen_ansehen",
      "individuelle_marketing_auswertungen_erstellen": "marketing.marketing_auswertungen.individuelle_marketing_auswertungen_erstellen",
      "marketing_auswertungen_speichern": "marketing.marketing_auswertungen.marketing_auswertungen_speichern",
      "marketing_auswertungen_exportieren": "marketing.marketing_auswertungen.marketing_auswertungen_exportieren",
    },
    marketing_zielgruppen_und_kommunikation: {
      "marketing_zielgruppen_verwenden": "marketing.marketing_zielgruppen_und_kommunikation.marketing_zielgruppen_verwenden",
      "marketing_kampagnen_einer_zielgruppe_zuordnen": "marketing.marketing_zielgruppen_und_kommunikation.marketing_kampagnen_einer_zielgruppe_zuordnen",
      "marketing_e_mail_versenden": "marketing.marketing_zielgruppen_und_kommunikation.marketing_e_mail_versenden",
      "marketing_sms_versenden": "marketing.marketing_zielgruppen_und_kommunikation.marketing_sms_versenden",
      "newsletter_versenden": "marketing.marketing_zielgruppen_und_kommunikation.newsletter_versenden",
      "kundenbereich_anzeige_veroeffentlichen": "marketing.marketing_zielgruppen_und_kommunikation.kundenbereich_anzeige_veroeffentlichen",
    },
    marketing_integrationen: {
      "marketing_integrationen_ansehen": "marketing.marketing_integrationen.marketing_integrationen_ansehen",
      "marketing_integration_verwenden": "marketing.marketing_integrationen.marketing_integration_verwenden",
      "marketing_integration_konfigurieren": "marketing.marketing_integrationen.marketing_integration_konfigurieren",
      "marketing_integration_de_aktivieren": "marketing.marketing_integrationen.marketing_integration_de_aktivieren",
      "marketing_integrationshistorie_ansehen": "marketing.marketing_integrationen.marketing_integrationshistorie_ansehen",
    },
  },
  testing: {
    tickets: {
      "tickets_ansehen": "testing.tickets.tickets_ansehen",
      "tickets_melden": "testing.tickets.tickets_melden",
      "tickets_bearbeiten": "testing.tickets.tickets_bearbeiten",
    },
    testdaten: {
      "testdaten_ansehen": "testing.testdaten.testdaten_ansehen",
      "testdaten_verwalten": "testing.testdaten.testdaten_verwalten",
    },
  },
  abnahme: {
    katalog: {
      "katalog_ansehen": "abnahme.katalog.katalog_ansehen",
      "katalog_bearbeiten": "abnahme.katalog.katalog_bearbeiten",
    },
    testlaeufe: {
      "testlaeufe_ansehen": "abnahme.testlaeufe.testlaeufe_ansehen",
      "testlaeufe_durchfuehren": "abnahme.testlaeufe.testlaeufe_durchfuehren",
    },
    freigabe: {
      "freigabe_ansehen": "abnahme.freigabe.freigabe_ansehen",
      "freigabe_erteilen": "abnahme.freigabe.freigabe_erteilen",
    },
  },
} as const;

export const PERMISSION_KEYS = [
  "dashboard.dashboard_ansehen",
  "dashboard.eigene_kennzahlen_ansehen",
  "dashboard.teamkennzahlen",
  "dashboard.standortkennzahlen",
  "dashboard.unternehmenskennzahlen",
  "dashboard.dashboard_konfigurieren",
  "dashboard.eigene_widgets_hinzufuegen_entfernen",
  "dashboard.individuelle_dashboards_erstellen",
  "dashboard.globale_dashboard_widgets_konfigurieren",
  "dashboard.globale_dashboards_verwalten",
  "arbeit.aufgaben.aufgaben_ansehen",
  "arbeit.aufgaben.aufgaben_erstellen",
  "arbeit.aufgaben.aufgabe_bearbeiten",
  "arbeit.aufgaben.aufgabe_erledigen",
  "arbeit.aufgaben.faelligkeit_aendern",
  "arbeit.aufgaben.aufgabe_zuweisen",
  "arbeit.aufgaben.aufgabe_delegieren",
  "arbeit.aufgaben.prioritaet_aendern",
  "arbeit.aufgaben.aufgabe_kommentieren",
  "arbeit.aufgaben.anhaenge_verwalten",
  "arbeit.aufgaben.datensaetze_verknuepfen",
  "arbeit.aufgaben.aufgabe_archivieren_ausblenden",
  "arbeit.aufgaben.aufgabe_loeschen",
  "arbeit.aufgaben.aenderungshistorie_ansehen",
  "arbeit.kalendereintraege.eigene_eintraege_ansehen",
  "arbeit.kalendereintraege.eintraege_erstellen",
  "arbeit.kalendereintraege.eigene_eintraege_bearbeiten",
  "arbeit.kalendereintraege.eigene_eintraege_loeschen",
  "arbeit.kalendereintraege.andere_teilnehmer_einladen",
  "arbeit.kalendereintraege.team_eintraege_ansehen",
  "arbeit.kalendereintraege.team_eintraege_verwalten",
  "personen.personen.person_ansehen",
  "personen.personen.person_erstellen",
  "personen.personen.person_bearbeiten",
  "personen.personen.person_archivieren",
  "personen.personen.person_loeschen",
  "personen.personen.person_zusammenfuehren",
  "personen.personen.personenhistorie_ansehen",
  "personen.personen.personenhistorie_bearbeiten",
  "personen.personen.personenhistorie_loeschen",
  "personen.personen.personendokumente_ansehen",
  "personen.personen.personendokumente_verwalten",
  "personen.accounts.account_ansehen",
  "personen.accounts.account_erstellen",
  "personen.accounts.account_bearbeiten",
  "personen.accounts.account_archivieren",
  "personen.accounts.account_loeschen",
  "personen.accounts.account_zugriff_verwalten",
  "personen.accounts.profile_eines_accounts_ansehen",
  "personen.accounts.account_historie_ansehen",
  "personen.profile.profile_ansehen",
  "personen.profile.profil_erstellen",
  "personen.profile.profil_bearbeiten",
  "personen.profile.profil_archivieren",
  "personen.profile.profil_loeschen",
  "personen.profile.profil_einem_account_zuordnen",
  "personen.profile.profil_aus_account_entfernen",
  "personen.profile.profilrolle_hinzufuegen",
  "personen.profile.profilhistorie_ansehen",
  "personen.profile.profil_dokumente_ansehen",
  "personen.profile.profil_dokumente_verwalten",
  "anfragen.anfragen_ansehen",
  "anfragen.anfragen_in_probestunde_umwandeln",
  "anfragen.anfrage_als_favoriten_hinzufuegen",
  "anfragen.anfrage_archivieren",
  "anfragen.anfrage_bearbeiten",
  "anfragen.anfrage_loeschen",
  "anfragen.anfragenhistorie_ansehen",
  "anfragen.anfragenhistorie_loeschen",
  "anfragen.anfrage_mit_person_verknuepfen",
  "anfragen.anruf_aus_anfrage_starten",
  "anfragen.sms_aus_anfrage_versenden",
  "anfragen.e_mail_aus_anfrage_versenden",
  "anfragen.kommentar_hinzufuegen",
  "anmeldung.eintrag_ansehen",
  "anmeldung.kuendigungen_ansehen",
  "anmeldung.eintrag_bearbeiten",
  "anmeldung.eintrag_archivieren",
  "anmeldung.eintrag_loeschen",
  "anmeldung.als_favorit_hinzufuegen",
  "anmeldung.einmalcode_ausstellen",
  "anmeldung.historie_einsehen",
  "anmeldung.historie_loeschen",
  "anmeldung.anruf_aus_eintrag_starten",
  "anmeldung.sms_aus_eintrag_versenden",
  "anmeldung.e_mail_aus_eintrag_versenden",
  "anmeldung.kommentar_hinzufuegen",
  "termine.eintraege_ansehen",
  "termine.eintraege_bearbeiten",
  "termine.eintraege_loeschen",
  "termine.kommentare_hinzufuegen",
  "raumplan.raeume_ansehen",
  "raumplan.raeume_bearbeiten",
  "raumplan.raeume_anlegen",
  "raumplan.raeume_de_aktivieren",
  "raumplan.raeume_loeschen",
  "raumplan.belegungsplan_bearbeiten",
  "raumplan.auslastung_ansehen",
  "raumplan.wirtschaftliche_kennzahlen_ansehen",
  "raumplan.raumhistorie_ansehen",
  "raumplan.kommentare_hinzufuegen",
  "personenlisten.personenlisten_ansehen",
  "personenlisten.personenlisten_erstellen",
  "personenlisten.personenliste_bearbeiten",
  "personenlisten.personenliste_teilen",
  "personenlisten.personenliste_archivieren",
  "personenlisten.personenliste_loeschen",
  "personenlisten.personen_einer_liste_ansehen",
  "personenlisten.personenliste_exportieren",
  "personenlisten.fuer_e_mail_verteiler_verwenden",
  "personenlisten.fuer_sms_verteiler_verwenden",
  "personenlisten.fuer_newsletter_verwenden",
  "personenlisten.fuer_kundenbereich_anzeige_verwenden",
  "personenlisten.personenliste_kommentieren",
  "buchhaltung.finanzdaten_und_zahlungen.finanzdaten_ansehen",
  "buchhaltung.finanzdaten_und_zahlungen.finanzdaten_bearbeiten",
  "buchhaltung.finanzdaten_und_zahlungen.zahlungen_ansehen",
  "buchhaltung.finanzdaten_und_zahlungen.zahlungen_bearbeiten",
  "buchhaltung.finanzdaten_und_zahlungen.zahlung_erfassen",
  "buchhaltung.finanzdaten_und_zahlungen.zahlung_zurueckerstatten",
  "buchhaltung.finanzdaten_und_zahlungen.offene_posten_ansehen",
  "buchhaltung.finanzdaten_und_zahlungen.offene_posten_bearbeiten",
  "buchhaltung.finanzdaten_und_zahlungen.liquiditaetsprognose_ansehen",
  "buchhaltung.ruecklastschriften_und_mahnwesen.ruecklastschriften_ansehen",
  "buchhaltung.ruecklastschriften_und_mahnwesen.ruecklastschriften_bearbeiten",
  "buchhaltung.ruecklastschriften_und_mahnwesen.mahnwesen_ansehen",
  "buchhaltung.ruecklastschriften_und_mahnwesen.mahnwesen_bearbeiten",
  "buchhaltung.ruecklastschriften_und_mahnwesen.mahnungen_erstellen_versenden",
  "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_ansehen",
  "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_erstellen",
  "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_bearbeiten",
  "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_archivieren",
  "buchhaltung.buchhaltungsbelege_und_dokumente.finanzdokumente_loeschen",
  "standort.standort_stammdaten.standortdaten_ansehen",
  "standort.standort_stammdaten.standortdaten_bearbeiten",
  "standort.standort_stammdaten.standort_archivieren",
  "standort.standort_stammdaten.standort_loeschen",
  "standort.standort_stammdaten.standorthistorie_ansehen",
  "standort.standort_stammdaten.kommentare_hinzufuegen",
  "standort.raeume_und_ausstattung.raumkonfiguration_ansehen",
  "standort.raeume_und_ausstattung.raumkonfiguration_bearbeiten",
  "standort.raeume_und_ausstattung.ausstattung_verwalten",
  "standort.raeume_und_ausstattung.kommentare_hinzufuegen",
  "standort.unterrichtsangebot.unterrichtsangebot_ansehen",
  "standort.unterrichtsangebot.unterrichtsangebot_bearbeiten",
  "standort.unterrichtsangebot.unterrichtsangebot_de_aktivieren",
  "standort.unterrichtsangebot.kommentare_hinzufuegen",
  "standort.unterrichtsformen_und_pakete.unterrichtsformen_ansehen",
  "standort.unterrichtsformen_und_pakete.unterrichtsformen_bearbeiten",
  "standort.unterrichtsformen_und_pakete.unterrichtsformen_de_aktivieren",
  "standort.unterrichtsformen_und_pakete.pakete_ansehen",
  "standort.unterrichtsformen_und_pakete.pakete_bearbeiten",
  "standort.unterrichtsformen_und_pakete.pakete_de_aktivieren",
  "standort.unterrichtsformen_und_pakete.kommentare_hinzufuegen",
  "standort.vertragsregularien.vertragsregularien_ansehen",
  "standort.vertragsregularien.vertragsregularien_bearbeiten",
  "standort.vertragsregularien.vertragsregularien_de_aktivieren",
  "standort.vertragsregularien.kommentare_hinzufuegen",
  "standort.vertragsregularien.historie_ansehen",
  "standort.benutzer_und_zugriffsrechte.standortbenutzer_ansehen",
  "standort.benutzer_und_zugriffsrechte.standortbenutzer_hinzufuegen",
  "standort.benutzer_und_zugriffsrechte.standortbenutzer_entfernen",
  "standort.benutzer_und_zugriffsrechte.standortbezogene_rolle_vergeben",
  "standort.benutzer_und_zugriffsrechte.standortbezogene_berechtigungen_bearbeiten",
  "standort.benutzer_und_zugriffsrechte.standortbenutzer_deaktivieren",
  "standort.benutzer_und_zugriffsrechte.benutzerhistorie_ansehen",
  "recruiting.jobangebote.jobangebote_ansehen",
  "recruiting.jobangebote.jobangebote_erstellen",
  "recruiting.jobangebote.jobangebote_bearbeiten",
  "recruiting.jobangebote.jobangebote_veroeffentlichen",
  "recruiting.jobangebote.jobangebote_deaktivieren",
  "recruiting.jobangebote.jobangebote_archivieren",
  "recruiting.jobangebote.jobangebote_loeschen",
  "recruiting.jobangebote.jobangebots_historie_ansehen",
  "recruiting.jobangebote.kommentar_hinzufuegen",
  "recruiting.bewerbungen.bewerbungen_ansehen",
  "recruiting.bewerbungen.bewerbungen_bearbeiten",
  "recruiting.bewerbungen.bewerbungen_archivieren",
  "recruiting.bewerbungen.bewerbung_loeschen",
  "recruiting.bewerbungen.bewerbung_einem_jobangebot_zuordnen",
  "recruiting.bewerbungen.bewerbungsstatus_aendern",
  "recruiting.bewerbungen.bewerbung_kommentieren",
  "recruiting.bewerbungen.bewerbungshistorie_ansehen",
  "recruiting.bewerbungen.bewerbungsdokumente_ansehen",
  "recruiting.bewerbungen.bewerbungsdokumente_verwalten",
  "recruiting.bewerbungen.bewerber_kontaktieren",
  "cms.inhalte.inhalte_ansehen",
  "cms.inhalte.inhalte_erstellen",
  "cms.inhalte.inhalte_bearbeiten",
  "cms.inhalte.inhalte_veroeffentlichen",
  "cms.inhalte.inhalte_deaktivieren",
  "cms.inhalte.inhalte_archivieren",
  "cms.inhalte.inhalte_loeschen",
  "cms.inhalte.medien_verwalten",
  "cms.inhalte.kommentare_hinzufuegen",
  "cms.inhalte.inhalte_historie_ansehen",
  "cms.website_struktur.website_struktur_ansehen",
  "cms.website_struktur.website_struktur_bearbeiten",
  "cms.website_struktur.seiten_erstellen",
  "cms.website_struktur.seiten_loeschen",
  "cms.website_struktur.seiten_verschieben",
  "cms.website_struktur.navigation_bearbeiten",
  "cms.website_struktur.website_hierarchie_bearbeiten",
  "auswertungen.standard_und_individuelle_auswertungen.auswertungen_ansehen",
  "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_erstellen",
  "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_speichern",
  "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_bearbeiten",
  "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_archivieren",
  "auswertungen.standard_und_individuelle_auswertungen.individuelle_auswertungen_loeschen",
  "auswertungen.standard_und_individuelle_auswertungen.auswertungen_exportieren",
  "auswertungen.standard_und_individuelle_auswertungen.auswertungen_kommentieren",
  "auswertungen.standard_und_individuelle_auswertungen.auswertungen_teilen",
  "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_verwenden",
  "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_speichern",
  "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_teilen",
  "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_exportieren",
  "auswertungen.ki_gestuetzte_auswertungen.ki_auswertungen_loeschen",
  "auswertungen.ki_gestuetzte_auswertungen.ki_datenzugriff_konfigurieren",
  "admin.globale_angebote.globale_angebote_ansehen",
  "admin.globale_angebote.globale_angebote_erstellen",
  "admin.globale_angebote.globales_angebot_bearbeiten",
  "admin.globale_angebote.globales_angebot_de_aktivieren",
  "admin.globale_angebote.globales_angebot_archivieren",
  "admin.globale_angebote.globales_angebot_loeschen",
  "admin.globale_angebote.historie_ansehen",
  "admin.globale_angebote.kommentare_hinzufuegen",
  "admin.standorte.standorte_ansehen",
  "admin.standorte.standort_anlegen",
  "admin.standorte.standort_bearbeiten",
  "admin.standorte.standort_archivieren",
  "admin.standorte.standort_loeschen",
  "admin.standorte.standorthistorie_ansehen",
  "admin.benutzer_und_rollen.benutzer_ansehen",
  "admin.benutzer_und_rollen.benutzer_anlegen",
  "admin.benutzer_und_rollen.benutzer_bearbeiten",
  "admin.benutzer_und_rollen.benutzer_de_aktivieren",
  "admin.benutzer_und_rollen.benutzer_loeschen",
  "admin.benutzer_und_rollen.rollen_vergeben",
  "admin.benutzer_und_rollen.berechtigungen_bearbeiten",
  "admin.benutzer_und_rollen.standortzuordnung_verwalten",
  "admin.benutzer_und_rollen.benutzerhistorie_ansehen",
  "admin.sicherheit.sicherheitseinstellungen_ansehen",
  "admin.sicherheit.sicherheitseinstellungen_bearbeiten",
  "admin.sicherheit.2fa_richtlinien_verwalten",
  "admin.sicherheit.passwortrichtlinien_verwalten",
  "admin.sicherheit.anmelderichtlinien_verwalten",
  "admin.sicherheit.sitzungsrichtlinien_verwalten",
  "admin.sicherheit.sicherheitsprotokolle_ansehen",
  "admin.sicherheit.benutzersitzungen_verwalten",
  "admin.sicherheit.sicherheitsereignisse_verwalten",
  "admin.migration_und_daten.migrationskonfiguration_ansehen",
  "admin.migration_und_daten.migrationskonfiguration_bearbeiten",
  "admin.migration_und_daten.datenimport_durchfuehren",
  "admin.migration_und_daten.datenexport_durchfuehren",
  "admin.migration_und_daten.migration_starten",
  "admin.migration_und_daten.migration_abbrechen",
  "admin.migration_und_daten.migration_archivieren",
  "admin.migration_und_daten.migration_loeschen",
  "admin.migration_und_daten.migrationshistorie_ansehen",
  "admin.migration_und_daten.import_exportprotokolle_ansehen",
  "admin.zahlungswesen_und_integrationen.zahlungsintegration_ansehen",
  "admin.zahlungswesen_und_integrationen.zahlungsintegration_konfigurieren",
  "admin.zahlungswesen_und_integrationen.zahlungsintegration_de_aktivieren",
  "admin.zahlungswesen_und_integrationen.zahlungsarten_konfigurieren",
  "admin.zahlungswesen_und_integrationen.zahlungsparameter_konfigurieren",
  "admin.zahlungswesen_und_integrationen.zahlungsintegration_testen",
  "admin.zahlungswesen_und_integrationen.zahlungsintegration_loeschen",
  "admin.zahlungswesen_und_integrationen.zahlungsintegrations_historie_ansehen",
  "admin.vorlagen.vorlagen_ansehen",
  "admin.vorlagen.vorlagen_verwenden",
  "admin.vorlagen.vorlagen_erstellen",
  "admin.vorlagen.vorlagen_bearbeiten",
  "admin.vorlagen.vorlagen_de_aktivieren",
  "admin.vorlagen.vorlagen_archivieren",
  "admin.vorlagen.vorlagen_loeschen",
  "admin.vorlagen.vorlagenhistorie_ansehen",
  "admin.vorlagen.kommentare_hinzufuegen",
  "admin.oeffentliche_bereiche.oeffentliche_bereiche_ansehen",
  "admin.oeffentliche_bereiche.oeffentliche_bereiche_bearbeiten",
  "admin.oeffentliche_bereiche.kunden_login_konfigurieren",
  "admin.oeffentliche_bereiche.oeffentliche_formulare_konfigurieren",
  "admin.oeffentliche_bereiche.oeffentliche_funktionen_de_aktivieren",
  "admin.oeffentliche_bereiche.oeffentliche_konfiguration_archivieren",
  "admin.oeffentliche_bereiche.oeffentliche_konfiguration_loeschen",
  "admin.oeffentliche_bereiche.historie_ansehen",
  "admin.system_und_schnittstellen.systemeinstellungen_ansehen",
  "admin.system_und_schnittstellen.systemeinstellungen_bearbeiten",
  "admin.system_und_schnittstellen.api_schnittstellen_ansehen",
  "admin.system_und_schnittstellen.api_schnittstellen_konfigurieren",
  "admin.system_und_schnittstellen.api_schnittstellen_de_aktivieren",
  "admin.system_und_schnittstellen.api_schnittstellen_testen",
  "admin.system_und_schnittstellen.api_schnittstellen_loeschen",
  "admin.system_und_schnittstellen.wartungsmodus_verwalten",
  "admin.system_und_schnittstellen.zeitzonen_verwalten",
  "admin.system_und_schnittstellen.terminintervalle_verwalten",
  "admin.system_und_schnittstellen.termin_ranges_verwalten",
  "admin.system_und_schnittstellen.systemhistorie_ansehen",
  "admin.storage_und_dateien.storage_ansehen",
  "admin.storage_und_dateien.storage_konfigurieren",
  "admin.storage_und_dateien.speicherbereiche_verwalten",
  "admin.storage_und_dateien.speicherlimits_konfigurieren",
  "admin.storage_und_dateien.dateien_verwalten",
  "admin.storage_und_dateien.dateien_loeschen",
  "admin.storage_und_dateien.storage_historie_ansehen",
  "admin.datenschutz.datenschutzeinstellungen_ansehen",
  "admin.datenschutz.datenschutzeinstellungen_bearbeiten",
  "admin.datenschutz.dsgvo_anfragen_ansehen",
  "admin.datenschutz.dsgvo_anfragen_bearbeiten",
  "admin.datenschutz.datenexport_fuer_betroffene_person_durchfuehren",
  "admin.datenschutz.loeschanfrage_bearbeiten",
  "admin.datenschutz.datensaetze_anonymisieren",
  "admin.datenschutz.aufbewahrungsregeln_verwalten",
  "admin.datenschutz.datenschutzprotokoll_ansehen",
  "admin.datenschutz.datenschutz_historie_ansehen",
  "admin.protokollierung_und_logs.logs_ansehen",
  "admin.protokollierung_und_logs.audit_logs_ansehen",
  "admin.protokollierung_und_logs.sicherheitslogs_ansehen",
  "admin.protokollierung_und_logs.integrationslogs_ansehen",
  "admin.protokollierung_und_logs.migrationslogs_ansehen",
  "admin.protokollierung_und_logs.logs_exportieren",
  "admin.protokollierung_und_logs.logs_loeschen",
  "admin.ki.ki_konfiguration_ansehen",
  "admin.ki.ki_konfiguration_bearbeiten",
  "admin.ki.ki_assistenten_verwalten",
  "admin.ki.ki_assistenten_de_aktivieren",
  "admin.ki.ki_datenzugriffe_verwalten",
  "admin.ki.ki_modelle_anbieter_verwalten",
  "admin.ki.ki_konfigurationshistorie_ansehen",
  "admin.automatisierung.automatisierung_ansehen",
  "admin.automatisierung.automatisierung_erstellen",
  "admin.automatisierung.automatisierung_bearbeiten",
  "admin.automatisierung.automatisierung_de_aktivieren",
  "admin.automatisierung.automatisierung_archivieren",
  "admin.automatisierung.automatisierung_loeschen",
  "admin.automatisierung.automatisierungshistorie_ansehen",
  "admin.unternehmen_und_erscheinungsbild.unternehmensdaten_ansehen",
  "admin.unternehmen_und_erscheinungsbild.unternehmensdaten_bearbeiten",
  "admin.unternehmen_und_erscheinungsbild.erscheinungsbild_ansehen",
  "admin.unternehmen_und_erscheinungsbild.erscheinungsbild_bearbeiten",
  "admin.unternehmen_und_erscheinungsbild.unternehmenskonfiguration_archivieren",
  "admin.unternehmen_und_erscheinungsbild.unternehmenshistorie_ansehen",
  "admin.unternehmen_und_erscheinungsbild.kommentare_hinzufuegen",
  "admin.verkaufsaktionen.gutscheine_und_rabattcodes_ansehen",
  "admin.verkaufsaktionen.gutscheine_und_rabattcodes_erstellen",
  "admin.verkaufsaktionen.gutscheine_und_rabattcodes_bearbeiten",
  "admin.verkaufsaktionen.gutscheine_und_rabattcodes_de_aktivieren",
  "admin.verkaufsaktionen.gutscheine_und_rabattcodes_archivieren",
  "admin.verkaufsaktionen.gutscheine_und_rabattcodes_loeschen",
  "admin.verkaufsaktionen.affiliate_codes_ansehen",
  "admin.verkaufsaktionen.affiliate_codes_bearbeiten",
  "admin.verkaufsaktionen.affiliate_codes_de_aktivieren",
  "admin.verkaufsaktionen.affiliate_codes_archivieren",
  "admin.verkaufsaktionen.affiliate_codes_loeschen",
  "admin.verkaufsaktionen.nutzung_ansehen",
  "admin.verkaufsaktionen.historie_ansehen",
  "marketing.kampagnen.kampagnen_ansehen",
  "marketing.kampagnen.kampagnen_erstellen",
  "marketing.kampagnen.kampagnen_bearbeiten",
  "marketing.kampagnen.kampagnen_de_aktivieren",
  "marketing.kampagnen.kampagnen_archivieren",
  "marketing.kampagnen.kampagnen_loeschen",
  "marketing.kampagnen.kampagnenhistorie_ansehen",
  "marketing.kampagnen.kommentare_hinzufuegen",
  "marketing.marketing_auswertungen.marketing_auswertungen_ansehen",
  "marketing.marketing_auswertungen.individuelle_marketing_auswertungen_erstellen",
  "marketing.marketing_auswertungen.marketing_auswertungen_speichern",
  "marketing.marketing_auswertungen.marketing_auswertungen_exportieren",
  "marketing.marketing_zielgruppen_und_kommunikation.marketing_zielgruppen_verwenden",
  "marketing.marketing_zielgruppen_und_kommunikation.marketing_kampagnen_einer_zielgruppe_zuordnen",
  "marketing.marketing_zielgruppen_und_kommunikation.marketing_e_mail_versenden",
  "marketing.marketing_zielgruppen_und_kommunikation.marketing_sms_versenden",
  "marketing.marketing_zielgruppen_und_kommunikation.newsletter_versenden",
  "marketing.marketing_zielgruppen_und_kommunikation.kundenbereich_anzeige_veroeffentlichen",
  "marketing.marketing_integrationen.marketing_integrationen_ansehen",
  "marketing.marketing_integrationen.marketing_integration_verwenden",
  "marketing.marketing_integrationen.marketing_integration_konfigurieren",
  "marketing.marketing_integrationen.marketing_integration_de_aktivieren",
  "marketing.marketing_integrationen.marketing_integrationshistorie_ansehen",
  "testing.tickets.tickets_ansehen",
  "testing.tickets.tickets_melden",
  "testing.tickets.tickets_bearbeiten",
  "testing.testdaten.testdaten_ansehen",
  "testing.testdaten.testdaten_verwalten",
  "abnahme.katalog.katalog_ansehen",
  "abnahme.katalog.katalog_bearbeiten",
  "abnahme.testlaeufe.testlaeufe_ansehen",
  "abnahme.testlaeufe.testlaeufe_durchfuehren",
  "abnahme.freigabe.freigabe_ansehen",
  "abnahme.freigabe.freigabe_erteilen",
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];

export const SCOPES = ["own", "team", "location", "company"] as const;
export type ScopeKey = (typeof SCOPES)[number];

export const CONDITION_KEYS = ["customer_service_context", "recruiting_context_only"] as const;
export type ConditionKey = (typeof CONDITION_KEYS)[number];
